import { icons } from "assets"

export const currencyMap = {
    ngn: "₦",
    eur: "€",
    usd: "$",
}
export const currencyNameMap = {
    ngn: "Naira",
    eur: "Euro",
    usd: "Dollar"
}
export const flagsMap = {
    ngn: icons.nigeria_small,
    usd: icons.usa_small,
    eur: icons.euro_small
}